import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IAutoCompleteInfluencer } from "@shared/lib/types/globalDiscovery";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { GlobalDiscoveryService } from "../services/globalDiscovery.service";

export const useAutoCompleteInfluencerSearch = ({
  text,
  work_platform_id,
}: {
  text: string;
  work_platform_id: string;
}) => {
  const { data, isFetching, isError, error } = useQuery<
    BackednResponse<{ data: IAutoCompleteInfluencer[] }>
  >({
    queryKey: ["auto-complete-influencer-search", text, work_platform_id],
    queryFn: () =>
      GlobalDiscoveryService.autoCompleteInfluencers({
        text,
        work_platform_id,
      }),
    enabled: !!text && !!work_platform_id,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    autoCompleteInfluencers: data?.data?.data || [],
    isFetching,
    isError,
  };
};
